import { create } from 'zustand'
import { CheckoutStoreType } from './types'

export const useCheckoutStore = create<CheckoutStoreType>()((set, get) => ({
  card: null,
  setCard: card => {
    set({ card })
  },
  attendancePrice: 0,
  setAttendancePrice: attendancePrice => {
    set({ attendancePrice })
  },
  cardInformation: null,
  setCardInformation: cardInformation => {
    set({ cardInformation })
  },
  paymentAddress: null,
  setPaymentAddress: paymentAddress => {
    set({ paymentAddress })
  },
  paymentMethod: null,
  setPaymentMethod: paymentMethod => {
    set({ paymentMethod })
  },
  discount: 0,
  setDiscount: discount => {
    set({ discount: discount })
  },
  couponCode: '',
  setCouponCode: couponCode => {
    set({ couponCode })
  },
  coupon: null,
  setCoupon: coupon => {
    set({ coupon })
  },
  finalPrice: () => {
    const { attendancePrice, discount } = get()
    if (attendancePrice === null) return null
    const price = attendancePrice - (discount ?? 0)
    return price.toFixed(2).replace('.', ',')
  },
}))
